import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import Logo from "@/components/Logo";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#F3F2F2] flex items-center justify-center px-5" data-testid="payment-cancel-page">
      <div className="bg-white border-2 border-[#12263A] p-10 max-w-md w-full" style={{ borderRadius: "32px" }}>
        <Logo size={40} />
        <XCircle size={44} className="text-[#FF6B57] mt-8" strokeWidth={2} />
        <h1 className="mt-4 text-[28px] font-black text-[#12263A] leading-tight">Compra cancelada</h1>
        <p className="mt-3 text-[15px] leading-[1.6] text-[#2A3D52]">
          No se ha realizado ningún cobro. Cuando quieras, tu Kiddio te está esperando.
        </p>
        <button
          onClick={() => navigate("/")}
          data-testid="back-home-btn"
          className="mt-6 px-6 py-4 rounded-[20px] bg-[#2E9EF0] text-[#12263A] border-2 border-[#12263A] font-bold hover:bg-[#12263A] hover:text-[#2E9EF0] transition-colors"
        >
          Volver a la tienda
        </button>
      </div>
    </div>
  );
}
